import { TOOGLE_BOOKING_FORM, SHOW_BOOKING_FORM } from '../constants';

const initialState = {
  bookingForm: false,
};

export const bookingForm = (state = initialState, action) => {
  switch (action.type) {
    case TOOGLE_BOOKING_FORM:
      return { ...state, bookingForm: !state.bookingForm };
    case SHOW_BOOKING_FORM:
      return { ...state, bookingForm: true };
    default:
      return state;
  }
};
